import { Component, Input, OnInit } from '@angular/core';

import { IDialogInfo } from '@core/interfaces';

@Component({
    selector: 'app-dialog-info',
    templateUrl: './dialog-info.component.html',
    styleUrls: ['./dialog-info.component.scss']
})
export class DialogInfoComponent implements OnInit {

    @Input() dialogInfo: IDialogInfo[];

    constructor() {
    }

    ngOnInit(): void {
    }

}
